<template>
  <div>
    <v-app-bar app class="nav" :class="{backcolor:scrolled}">
      <v-app-bar-nav-icon class="ico-bar" color="white"  @click="drawer = !drawer"  v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
        <button class="hamburger hamburger--elastic" :class="{'is-active':drawer}" type="button">
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>
      </v-app-bar-nav-icon>
      <v-toolbar-title class="logo"><img :src="require('@/assets/images/gepres-blogs.svg')" alt="logo" class="logo-img" srcset=""></v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn to="/" text class="white--text">
          Inicio
        </v-btn>
        <v-btn to="/blogs" text class="white--text">
          Blogs
        </v-btn>
        <v-btn to="/about" text class="white--text">
          Acerca
        </v-btn>
        <v-btn to="/contact" text class="white--text">
          Contacto
        </v-btn>
        <v-btn to="/Admin" v-show="this.$store.state.showAdmin" text class="white--text">
          Admin
        </v-btn>
         <v-btn to="/login" text v-show="this.$store.state.showLogin" class="white--text">
          Ingresar
        </v-btn>
        <v-btn to="/login"  outlined large fab color="white" v-show="!this.$store.state.showLogin" @click="salir" class="white--text">
          salir
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <!-- navigation-drawer  -->
    <v-navigation-drawer class="navigation-drawer" color="white" v-model="drawer" app v-if="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
      <v-list-item class="justify-center">
        <v-list-item-avatar>
          <v-img :src="require('@/assets/images/gepres-blogs-mini.svg')"></v-img>
        </v-list-item-avatar>
      </v-list-item >
      <v-divider></v-divider>
      <v-list class="lista" dense nav>
        <v-list-item class="lista-li" link to="/">
          <v-list-item-content>
            <v-list-item-title>Inicio</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="lista-li" link to="/blogs">
            <v-list-item-title>Blogs</v-list-item-title>
        </v-list-item>
        <v-list-item class="lista-li" link to="/about">
            <v-list-item-title>Acerca</v-list-item-title>
        </v-list-item>
        <v-list-item class="lista-li" link to="/contact">
            <v-list-item-title>Contacto</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="this.$store.state.showAdmin" class="lista-li" link to="/admin">
            <v-list-item-title>Admin</v-list-item-title>
        </v-list-item>
        <v-list-item v-if="this.$store.state.showLogin" class="lista-li" link to="/login">
            <v-list-item-title>Ingresar</v-list-item-title>
        </v-list-item>
        <v-list-item v-show="!this.$store.state.showLogin" @click="salir" class="lista-li" link to="/login">
            <v-list-item-title>Salir</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>

  export default {
    name:'navigation',
    created(){
      if(localStorage.getItem('token') !== null){
        this.$store.state.showAdmin = true
        this.$store.state.showLogin = false
      }
    },
    mounted() {
      window.addEventListener("scroll", this.onScroll)
       this.onScroll()
    },
    beforeDestroy() {
      window.removeEventListener("scroll", this.onScroll)
    },
    data(){
      return {
        windowTop:0,
        scrolled:false,
        drawer: false
      }
    },
    methods:{
      onScroll(e) {
        this.windowTop = window.top.scrollY
        
        if(this.windowTop < 70 && window.matchMedia("(min-width: 960px)").matches) {
          this.scrolled = false
        }else if(this.windowTop < 50 && window.matchMedia("(max-width:960px)").matches){
           this.scrolled = false
        }else{
           this.scrolled = true
        }

      },
      salir(){
        localStorage.clear()
        this.$router.push('/')
        this.$store.state.showAdmin = false
        this.$store.state.showLogin = true
      }
    }
  }
</script>

<style lang="scss" scoped>
.ico-bar span i{
  font-size:2.2rem !important;
}
.nav{
  background: rgba(47, 22, 64,0.3) !important;
  color:#2F1640;
  padding: 0 70px 0 70px;
  transition: all .5s ease !important;
  @media screen and (max-width:960px){
    padding: 0;
  }
}
.nav-button{
  margin-right: 1rem;
}
.backcolor{
  background: #2F1640 !important;
  transition: all 1s ease !important;
  color:#fff !important;
}
.btn-nav{
  background:none !important;
  box-shadow: none;
}
.logo{
  width: 180px;
  display: flex;
  &-img{
    width: 100%;
  }
}
.navigation-drawer{
  top:56px !important;
}
// lista drawer
.lista{
  &-li{
    text-align: center;
    color:#2F1640 !important;
  }
}
</style>
<style lang="scss">
.v-overlay__scrim{
  top:56px !important;
}
.hamburger.is-active .hamburger-inner,
  .hamburger.is-active .hamburger-inner::before,
  .hamburger.is-active .hamburger-inner::after {
    background-color: #fff !important; }
 .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after{
   background-color: #fff !important;
 }
 .hamburger-box{
   width:30px !important;
 }
 .hamburger{
   padding: 0 !important;
 }
 .hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
    width:30px !important;
 }
</style>